var React = require('react');

function PinDotted (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6 1.33333 8.66667 4 12C6.66667 8.66667 8 6 8 4ZM2.5 4C2.5 3.17157 3.17157 2.5 4 2.5C4.82843 2.5 5.5 3.17157 5.5 4C5.5 4.82843 4.82843 5.5 4 5.5C3.17157 5.5 2.5 4.82843 2.5 4Z","fill":"white"}));
}

PinDotted.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = PinDotted;

PinDotted.default = PinDotted;
